<template>
    <div id="nav-header-box" class="clearfix">
        <nav class="navbar navbar-expand-lg navbar-dark">
            <router-link class="navbar-brand" to="/">
                <img :src="require('../../public/images/h3.jpg')" alt="" loading="lazy">
            </router-link>
            <button class="navbar-toggler bg-secondary" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
    
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li v-for="(item,key) in navData" :key="key" :class="['nav-item','px-md-2',item.index == navIndex? 'active': '']" >
                        <router-link class="nav-link" :to="item.path">{{item.name}}</router-link>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
    </template>
    <script>
    import { mapState } from 'vuex';
    
    export default {
        name: "",
        data() {
            return {
                navData: [
                    {
                        name: "首页",
                        path: "/",
                        index: 0,
                    },
                    {
                        name: "我们的酒庄",
                        path: "/winery",
                        index: 1,
                    },
                    {
                        name: "精选美酒",
                        path: "/wine",
                        index: 2,
                    },
                    {
                        name: "葡旅空间",
                        path: "/zoom",
                        index: 3,
                    },
                    {
                        name: "美酒生活",
                        path: "/life",
                        index: 4,
                    },
                    {
                        name: "联系我们",
                        path: "/contact",
                        index: 5,
                    },
                ]
            }
        },
        computed: {
            ...mapState(['navIndex'])
        },
        methods: {
            /**
             * @desc 跳转路由
             */
            goChildren(path,query,event) {
                event.stopPropagation();
                this.$router.push({
                    path,
                    query
                })
            }
        },
        mounted() {
        }
    }
    </script>
    <style lang="scss" scoped>
    #nav-header-box {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;
        .navbar {
            padding: 0 20px;
            background: #6a0b2d;
            // height: 2.07rem;
    
            .navbar-toggler-icon {
                width: 35px;
                height: 35px;
                display: block;
                background-image: url(../assets/menu.png) !important;
            }
    
            .navbar-nav {
                .nav-link {
                    padding: 0;
                    position: relative;
                    height: 30px;
                    color: #fff;
                    font-size: 20px;
                    line-height: 30px;
    
                    a {
                        color: #fff;
                        text-decoration: none;
                    }
                }

                .nav-item{
                    line-height: 2rem;
                    padding-bottom: 26px;
                    a{
                        font-size: 1.8rem;
                    }
                }
    
                .active {
                    .nav-link {
                        color: #b15f4a;
                    }
                }
            }
        }
        .navbar-toggler {
            border: 0rem;
            padding: 12px;
            border-radius: 10px;
            font-size: 62px;
            background-color: #fff !important;
        }
    
        .navbar-brand {
            display: block;
            padding: 0;
            font-size: 100px;
            margin-right: 50px;
    
            img {
                width: 250px;
            }
            // position: absolute;
        }
    }
    </style>